import { render } from "./zjdShow.vue?vue&type=template&id=084f59e8&scoped=true"
import script from "./zjdShow.vue?vue&type=script&lang=js"
export * from "./zjdShow.vue?vue&type=script&lang=js"

import "./zjdShow.vue?vue&type=style&index=0&id=084f59e8&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084f59e8"]])

export default __exports__